// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@5.2.5_webpack@4.47.0_webpack-cli@4.10.0_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".plv-iar-toast{position:fixed;top:50%;left:50%;transform:translate(-50%, -50%);padding:8px 16px;font-size:14px;color:#fff;text-align:center;background-color:rgba(0,0,0,.6);border-radius:18px;z-index:99999}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
